/** Shared pill label + class maps for orders and draft-order linked orders. */

export const FINANCIAL_PILLS = {
  pending: { label: 'awaiting payment', className: 'pill-button-red' },
  authorized: { label: 'authorized', className: 'pill-button-yellow' },
  partially_paid: { label: 'partially paid', className: 'pill-button-yellow' },
  paid: { label: 'paid', className: 'pill-button-green' },
  partially_refunded: { label: 'partially refunded', className: 'pill-button-pink' },
  refunded: { label: 'refunded', className: 'pill-button-expired' },
  voided: { label: 'voided', className: 'pill-button-expired' },
  expired: { label: 'expired', className: 'pill-button-expired' },
  // canceled: { label: 'canceled', className: 'pill-button-expired' },
};

export const FULFILLMENT_PILLS = {
  fulfilled: { label: 'fulfilled', className: 'pill-button-green' },
  open: { label: 'open', className: 'pill-button-blue' },
  in_progress: { label: 'in progress', className: 'pill-button-orange' },
  partially_fulfilled: { label: 'partially fulfilled', className: 'pill-button-orange' },
  unfulfilled: { label: 'in progress', className: 'pill-button-yellow' },
  scheduled: { label: 'scheduled', className: 'pill-button-grey' },
  on_hold: { label: 'on hold', className: 'pill-button-yellow' },
  pending_fulfillment: { label: 'pending fulfillment', className: 'pill-button-grey' },
  restocked: { label: 'restocked', className: 'pill-button-grey' },
};

export function humanizeStatus(status) {
  return String(status).replace(/_/g, ' ').toLowerCase();
}
